import { configEnum } from '../../enums/fetchFactoryEnum'

export const checkTokenValidity = (token: string) => new Promise((resolve, reject) => {
	fetch(`/api/ec_${process.env.REACT_APP_TARGET}/okta/checkTokenValidity`,
		{
			method: configEnum.post,
			body: JSON.stringify({ token })
		}
	)
		.then(
			response => {
				if (response.ok) {
					resolve()
				} else {
					reject()
				}
			}
		).catch((error) => reject(error))
})